$(document).ready(function () {
  const isMobile = document.documentElement.clientWidth < 1025

  if (isMobile) {
    const homepageCasesSwiper = new Swiper('.homepage-cases-swiper', {
      slidesPerView: 1.2,
      breakpoints: {
        320: {
          spaceBetween: 18,
          slidesPerView: 1.1
        },
        768: {
          spaceBetween: 24,
          slidesPerView: 1.2
        }
      }
    })
  }
  const slides = document.querySelectorAll('.numbers');
  const slidesArray = Array.from(slides);
  const indexesToHide = [0, 1,3];

  indexesToHide.forEach(index => {
    if(slidesArray[index]){
      slidesArray[index].style.display = 'none';
    }
  })
  console.log("Elements at indexes 0, 1, 3 are now hidden.");
})
